import { FC } from 'react';
import { usePOICoverImage, usePOIDescription, usePOILinkPreviewTitle } from '@poi/shared/use-poi-tdk';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';
import { useOGImageUrl } from '~/utils/libra/og-image-opt';
import { useAtomValue } from 'jotai';
import { $CurrentPOIInfoAsAvailable } from '../shared/current-poi-info';

export const POITwitter: FC = () => {
  const title = usePOILinkPreviewTitle();
  const poi = useAtomValue($CurrentPOIInfoAsAvailable);

  const description = usePOIDescription();
  const cover = usePOICoverImage();
  const imageMeta = useOGImageUrl({
    url: cover?.url || '',
    width: cover?.width,
    height: cover?.height,
    text: cover?.url ? undefined : poi.formattedAddress || '',
  });

  return (
    <DynamicHead>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lemon8" />
      <meta name="twitter:text:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageMeta.url} />
    </DynamicHead>
  );
};
